import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import AccountOwnerEditor from './editor';

@modal(
  {
    className: 'partner-register-city-editor-modal',
  },
  true,
)
class AccountOwnerEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { editParams } = this.props;

    return (
      <div className="partner-register-city-editor">
        <div className="partner-register-city-editor__header" style={{ paddingBottom: '24px' }}>
          Edit Account Owner
          <CloseOutlined
            className="partner-register-city-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <AccountOwnerEditor
          partnerId={editParams.partnerId}
          currentOwnerId={editParams.currentOwnerId}
          partnerCountrySlug={editParams.partnerCountrySlug}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

AccountOwnerEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

AccountOwnerEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default AccountOwnerEditorContainer;
